var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgQrCode = function SvgQrCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "qr_code_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#qr_code_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.25 7.025a.726.726 0 0 1-.75-.75v-2.9c0-.25.083-.458.25-.625a.848.848 0 0 1 .625-.25h2.9a.728.728 0 0 1 .75.75.726.726 0 0 1-.75.75H4v2.275a.728.728 0 0 1-.75.75ZM3.375 21.5a.848.848 0 0 1-.625-.25.848.848 0 0 1-.25-.625v-2.9a.726.726 0 0 1 .75-.75.728.728 0 0 1 .75.75V20h2.275a.728.728 0 0 1 .75.75.728.728 0 0 1-.75.75h-2.9Zm14.35 0a.728.728 0 0 1-.75-.75.728.728 0 0 1 .75-.75H20v-2.275a.728.728 0 0 1 .75-.75.728.728 0 0 1 .75.75v2.9c0 .25-.083.458-.25.625a.848.848 0 0 1-.625.25h-2.9ZM20.75 7.025a.728.728 0 0 1-.75-.75V4h-2.275a.726.726 0 0 1-.75-.75.728.728 0 0 1 .75-.75h2.9c.25 0 .458.083.625.25.167.167.25.375.25.625v2.9a.728.728 0 0 1-.75.75Zm-3.525 10.2h1.35v1.35h-1.35v-1.35Zm0-2.725h1.35v1.375h-1.35V14.5Zm-1.35 1.375h1.35v1.35h-1.35v-1.35Zm-1.375 1.35h1.375v1.35H14.5v-1.35Zm-1.35-1.35h1.35v1.35h-1.35v-1.35Zm2.725-2.725h1.35v1.35h-1.35v-1.35ZM14.5 14.5h1.375v1.375H14.5V14.5Zm-1.35-1.35h1.35v1.35h-1.35v-1.35Zm5.425-7.725v5.425H13.15V5.425h5.425ZM10.85 13.15v5.425H5.425V13.15h5.425Zm0-7.725v5.425H5.425V5.425h5.425Zm-1.2 11.95V14.35H6.625v3.025H9.65Zm0-7.725V6.625H6.625V9.65H9.65Zm7.725 0V6.625H14.35V9.65h3.025Z",
    fill: "#FF9145"
  }))));
};

export default SvgQrCode;